import * as React from 'react';
import Svg, {Circle} from 'react-native-svg';
interface IProps {
  color?: string;
  size?: number;
}
const RadioUnchecked = ({color = '#707070', size = 24}: IProps) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <Circle cx={12} cy={12} r={11} stroke={color} strokeWidth={2} />
  </Svg>
);
export default RadioUnchecked;
